import type { Resource } from '../../';
export const product_details_addToCart_addSize: Resource = {"default":"Please Select a Size"};
